<script setup lang="ts">
import { ChevronLeft } from 'lucide-vue-next'
import { useFlowEditorContext } from '../composables/useFlowEditor'
import FlowHistoryPanel from './FlowHistoryPanel.vue'
import FlowPreviewPanel from './FlowPreviewPanel.vue'

/** Collapsible right rail with the live preview and the history list. */
const { rightRailCollapsed } = useFlowEditorContext().ui
</script>

<template>
  <aside
    class="flow-right-rail"
    :class="{ 'flow-right-rail--collapsed': rightRailCollapsed }"
    aria-label="History rail"
  >
    <!-- Collapsed: just the expand button -->
    <div v-if="rightRailCollapsed" class="rail-collapsed-strip">
      <button
        type="button"
        class="panel-collapse-btn"
        :title="$t('flow.expandPanel')"
        @click="rightRailCollapsed = false"
      >
        <ChevronLeft style="width: 0.9rem; height: 0.9rem" aria-hidden="true" />
      </button>
    </div>

    <!-- Expanded: full preview + history -->
    <template v-else>
      <!-- ── Preview ────────────────────────────────────────────── -->
      <FlowPreviewPanel />

      <!-- ── History ─────────────────────────────────────────────── -->
      <FlowHistoryPanel />
    </template>
  </aside>
</template>

<style scoped src="./styles/panelCollapse.css"></style>

<style scoped>
.flow-right-rail--collapsed {
  overflow: hidden;
}

.rail-collapsed-strip {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0.15rem 0 0;
  flex: 0 0 auto;
}
</style>
